import React from 'react';
import { ListItem, ListItemText, ListItemSecondaryAction, ListItemAvatar, Avatar } from '@material-ui/core';
import { entityService } from './services/entity-service';
import { withCoreContext } from '../context/with-core-context';
const EntityListItem = (props) => {
    const { schema, entity, context, SecondaryAction } = props;
    const instanceDisplayProps = entityService.instanceDisplayPropsOrDefault(schema, context)(entity);
    const listItemProps = {
        ...props,
    };
    delete listItemProps['SecondaryAction'];
    return (React.createElement(ListItem, Object.assign({}, listItemProps),
        React.createElement(ListItemAvatar, null,
            React.createElement(Avatar, { src: instanceDisplayProps.imageUrl }, schema.options.icon ? React.createElement(schema.options.icon, null) : schema.options.alias[0].toUpperCase())),
        React.createElement(ListItemText, { primaryTypographyProps: { noWrap: true }, secondaryTypographyProps: { noWrap: true }, primary: instanceDisplayProps.primaryText, secondary: instanceDisplayProps.secondaryText }),
        SecondaryAction && React.createElement(ListItemSecondaryAction, null, SecondaryAction)));
};
export default withCoreContext(EntityListItem);
